import insta_icon from '../assets/insta-ico.svg'
import linkedin_logo from '../assets/linkedin-ico.svg'

export function AppContact() {
    return (<div className='flex-row' style={{
        margin: 20
    }}>
        <a href="https://www.instagram.com/saytome2022">
            <div className='flex-row center-both'>
                <img src={insta_icon} alt="" style={{
                    width: 30,
                    height: 30
                }} />
                <h4>saytome2022</h4>
            </div>
        </a>
        <div style={{
            width: 30
        }}></div>
        <a href="https://linkedin.com/in/saytome">
            <div className='flex-row center-both'>
                <img src={linkedin_logo} alt="" style={{
                    width: 30,
                    height: 30
                }} />
                <h4>saytome</h4>
            </div>
        </a>
    </div>);
}